import { getDriverList, getVehicleList } from '@/api/capacity';
import { getEnum } from '@/api/getEnum';
import { extent } from '@/utils/dictionary/waybillselect';

const storeModelName = 'vehicleModule';
const state = {
  vehicleProperty: 'transfer',
  // 筛选项
  parameters: [
    {
      style: 'input',
      value: '',
      label: '车牌号',
      placeholder: '请输入',
      clearable: true,
      param: 'vehicleNo',
    },

    {
      style: 'select',
      param: 'driverMobile',
      value: '',
      valueType: 'string',
      label: '司机',
      placeholder: '请输入',
      noMatchText: '无匹配请输入',
      clearable: true,
      filterable: true,
      state: 'driverList',
      path: `${storeModelName}/getDriverList`,
    },
    {
      style: 'select',
      param: 'carryCargoLength',
      value: '',
      valueType: 'string',
      state: 'extent',
      label: '车长',
      placeholder: '请选择',
      clearable: true,
      filterable: false,
    },

    {
      style: 'select',
      param: 'vehicleModel',
      value: [],
      valueType: 'array',
      state: 'vehicleTypeList',
      label: '车型',
      placeholder: '请选择',
      clearable: true,
      filterable: false,
      multiple: true,
    },
    {
      style: 'date-picker',
      value: [],
      label: '创建时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      param: 'createTime',
      params: ['startCreateTime', 'endCreateTime'],
    },
  ],
  // 筛选项 select需要的列表
  colorList: [
    { label: '黄色', value: '黄色' },
    { label: '黄绿色', value: '黄绿色' },
    { label: '蓝色', value: '蓝色' },
    { label: '渐变绿色', value: '渐变绿色' },
  ],
  fuelTypeList: [
    { label: '柴油', value: '柴油' },
    { label: '天然气', value: '天然气' },
    { label: '汽油', value: '汽油' },
    { label: '新能源/电', value: '新能源/电' },
    { label: '液化石油气', value: '液化石油气' },
  ],
  vehicleTypeList: [],
  convoyList: [],
  driverList: [],
  // 配置是否导出
  isExport: {
    isShow: false,
  },
  // 接口调用参数
  postParams: {
    page: 1,
    size: 10,
  },
  // 列表data数据
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '车牌号',
        prop: 'vehicleNo',
        checked: 1,
        width: 80,
        sortable: true,
      },
      {
        label: '车牌颜色',
        prop: 'vehicleColor',
        checked: 1,
        width: 80,
        sortable: true,
      },
      {
        label: '车长',
        prop: 'carryCargoLength',
        checked: 1,
        width: 80,
        sortable: true,
      },
      {
        label: '车型',
        prop: 'vehicleModel',
        checked: 1,
        width: 80,
        sortable: true,
        slotName: 'sub-domain-vehicleModel',
      },
      {
        label: '行驶证',
        prop: 'licenseIsComplete',
        width: 100,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-licenseIsComplete',
      },
      {
        label: '道路运输证',
        prop: 'transportIsComplete',
        width: 100,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-transportIsComplete',
      },
      {
        label: '关联司机',
        prop: 'driverNames',
        checked: 1,
        width: 120,
        sortable: true,
        slotName: 'sub-domain-driverNames',
      },
      {
        label: '创建时间',
        prop: 'createTime',
        checked: 1,
        width: 120,
        sortable: true,
        slotName: 'sub-domain-createTime',
      },
      {
        label: '操作',
        prop: '',
        width: 100,
        checked: 1,
        sortable: true,
        fixed: 'right',
        slotName: 'sub-domain-status',
      },
    ],
    total: 0,
  },
  total: 0,
  from: '',
  report: {},
  reportAll: {},
  batchStatus: '',
  extent, // 载货长度
};

// getters
const getters = {};

// actions

const actions = {
  // 获取列表数据
  getList: async (context, payload) => {
    const params = {};
    context.state.parameters.forEach(item => {
      if (item.style !== 'date-picker' && item.value) {
        if (item.multiple && item.value === 'string') {
          params[item.param] = item.value.toString();
        } else {
          params[item.param] = item.value;
        }
      }
      if (item.style === 'date-picker' && item.value.length > 0) {
        params[item.params[0]] = `${item.value[0]} 00:00:00`;
        params[item.params[1]] = `${item.value[1]} 23:59:59`;
      }
    });
    getVehicleList(
      Object.assign(
        {},
        {
          page: context.state.postParams.page,
          size: context.state.postParams.size,
        },
        params,
        { vehicleProperty: context.state.vehicleProperty },
      ),
    ).then(res => {
      context.commit('updateListData', Object.assign({}, context.state.listData, res.data));
    });
  },
  getVehicleTypeEnum: async (context, payload) => {
    const { data } = await getEnum({
      UIEnumType: 'VehicleModel',
    });
    const obj = [];
    data.forEach(item => {
      obj.push({ label: item, value: item });
    });
    context.commit('updateVehicleTypeList', obj);
  },
  getDriverList: async (context, payload) => {
    const { data } = await getDriverList({
      vehicleProperty: 'transfer',
      name: payload,
    });
    const obj = [];
    data.list.forEach(item => {
      obj.push({ label: item.name, value: item.mobile });
    });
    context.commit('updateDriverList', obj);
  },
};

// mutations
const mutations = {
  // 更新data数据
  updateListData(state, payload) {
    state.listData = payload;
  },
  // 更新筛选
  //   updateEditParams(state, payload) {
  //     state.parameters = payload === 'transfer' ? state.transferParams : state.ownParams;
  //   },
  // 更新列表表头数据
  updateEditTableList(state, payload) {
    state.listData.tableHeadList = payload;
  },
  // 更新进入页面
  updateFrom(state, payload) {
    state.from = payload;
  },
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },
  // 更新网货列表
  updateConvoyList(state, payload) {
    state.convoyList = payload;
  },
  // 更新网货列表
  updateOrderList(state, payload) {
    state.orders = payload;
  },
  // 更新车型枚举
  updateVehicleTypeList(state, payload) {
    state.vehicleTypeList = payload;
  },
  updateDriverList(state, payload) {
    state.driverList = payload;
  },
  // 更新销售经理列表
  updateSales(state, payload) {
    state.sales = payload;
  },
  // 更新线路列表
  updateOrders(state, payload) {
    state.orders = payload;
  },
  // 更新统计信息
  updateReport(state, payload) {
    state.report = payload;
  },
  // 更新统计信息
  updateReportAll(state, payload) {
    state.reportAll = payload;
  },
  // 重置所有状态
  initFilter(state) {
    state.vehicleProperty = 'transfer';
    state.postParams = {
      size: 10,
      page: 1,
    };
    state.parameters.forEach(item => {
      if (item.style !== 'date-picker' && item.value) {
        if (item.multiple) {
          item.value = [];
        } else {
          item.value = '';
        }
      }
      if (item.style === 'date-picker') {
        if (item.param === 'createTime') {
          item.value = [];
        }
      }
    });
    state.driverList = [];
    // state.vehicleTypeListAll = [];
    state.vehicleModel = [];
    state.convoyList = [];
  },
  updateVehicleProperty(state, payload) {
    state.vehicleProperty = payload;
  },
  // 根据index更新value
  updateValueFromIndex(state, payload) {
    state.parameters[payload.index].value = payload.value;
  },
  // 根据index更新状态
  updateSpecialStatusFromIndex(state, payload) {
    state.isSpecialButton[payload.index].selectList.forEach((item, index) => {
      item.isActive = index === payload.index1;
    });
  },
  // 根据index更新状态
  updateSpecialTabsStatusFromIndex(state, payload) {
    state.isSpecialTabs[0].selectList.forEach((item, index) => {
      item.isActive = index === payload.index;
    });
    state.isSpecialTabs[0].status = state.isSpecialTabs[0].selectList[payload.index].value;
  },
  updateBatchChange(state, payload) {
    state.batchStatus = payload;
  },
  // 更行行内数据
  updateTableDataByIndex(state, payload) {
    state.listData.list[payload.index] = payload.info;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
